import * as MaxAds from './applovin_max.js';
import { SessionController } from '../socket_handler/controllers/session_controller.js';
import { NetworkManager } from '../network_manager.js';
import { areAdsBlockedOffline } from './offline_ads.js';
import { AdsConfigService } from './ads_config.js';
import { OfferService } from '../offers/offer_service.js';
import { countInterstitialLevel } from './interstitial_frequency.js';

export function recordInterstitialLevelPassed( level = AdsConfigService.getCurrentLevel() ): void
{
  if ( OfferService.hasNoInterstitialAds() ) return;

  const levels_passed = countInterstitialLevel( AdsConfigService.get().inter, level );
  console.log( '[ADS_INTERSTITIAL] level passed', { level, levels_passed } );
}

export async function tryShowInterstitial( placement_id = 'interstitial', level?: number ): Promise<boolean>
{
  if ( areAdsBlockedOffline() )
  {
    console.log( '[ADS_INTERSTITIAL] offline, interstitial blocked', { placement_id } );
    return false;
  }

  const shown = await MaxAds.tryShowInterstitial( placement_id, level );
  if ( shown )
  {
    if ( NetworkManager.isOnline() )
      await SessionController.sendInterstitialImpressionPerSession();
    else
      void SessionController.sendInterstitialImpressionPerSession();
  }
  return shown;
}

export async function preloadInterstitial(): Promise<void>
{
  await MaxAds.prepareInterstitial();
}
